// Use $ instead of $ without replacing global $
(function ($) {

  // tabs function

  var firsttab_id = $('.products-categories-tabs .nav-pills li a:first-child').attr('data-tab');
  $('.products-categories-tabs .process-list li[data-tab=' + firsttab_id + ']').addClass('active');
  $('.products-categories-tabs .process-list .link-icon[data-tab=' + firsttab_id + ']').addClass('active');

  $(document).ready(function () {

    $('.products-categories-tabs .nav-pills li a').on('click', function (e) {
      e.preventDefault();
      var tab_id = $(this).attr('data-tab');

      $('.products-categories-tabs .nav-pills li a').removeClass('active');
      $('.products-categories-tabs .tab-content-outer .tab-content .tab-pane').removeClass('active show');

      $(this).addClass('active');
      $("#" + tab_id).addClass('active show');
      $('.products-categories-tabs .process-list li[data-tab]').removeClass('active');
      $('.products-categories-tabs .process-list .link-icon[data-tab]').removeClass('active');
      $('.products-categories-tabs .process-list li[data-tab=' + tab_id + ']').addClass('active');
      $('.products-categories-tabs .process-list .link-icon[data-tab=' + tab_id + ']').addClass('active');

      if ($(this).hasClass('active')) {
        $('.products-categories-tabs .nav-pills li').removeClass('active');
        $(this).parent('li').addClass('active')
      }

      var winWidth = $(window).width();
      if (winWidth <= 767) {
        var tabHeight = $('.products-categories-tabs .tabs-wrap .tab-content-outer .tab-content').outerHeight();
        $('.products-categories-tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});
        var text = $(this).text();
        // console.log(text);
        $('.products-categories-tabs button .text').html(text);
      } else {
        $('.products-categories-tabs .tabs-wrap .tab-content-outer').removeAttr('style');
      }
    });

    $(document).on('click', '.products-categories-tabs .tab-list .tab-panel-outer .private-toggle', function (event) {
      event.stopPropagation();
      $('.products-categories-tabs .tab-list .tab-panel-outer ul').stop(true, true).slideToggle();
      $(".products-categories-tabs .tab-list .tab-panel-outer .caret").toggleClass("closeup");
    });


    $('.products-categories-tabs .tab-list').on('click', '.tab-panel-outer > ul > li > a', function () {
      var index = $(this).index();
      var $thisText = $(this).text();
      var tab_id = $(this).attr('data-tab');

      $(this).parents('ul').find('li > a').removeClass('active');
      $(this).parents('.tabs-wrap').find('.tab-content-outer .tab-content .tab-pane').removeClass('active');

      $('.products-categories-tabs .responsive-tab li a').removeClass('active');
      $(this).addClass('active');
      $('.tab-content-outer .tab-content .tab-pane').removeClass('active show');
      $("#" + tab_id).addClass('active show');
      $(this).parents('.tabs-wrap').find('.tab-content-outer .tab-content .tab-pane:eq(' + index + ')').addClass('active');

      //change text of filter
      $(".products-categories-tabs .tab-list .tab-panel-outer .text").text($thisText);


      var windowWidth = $(window).width();
      if (windowWidth <= 767) {
        $('.products-categories-tabs .tab-list .tab-panel-outer ul').stop(true, true).slideUp();
        $(".products-categories-tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");

      }

    });


    $(document).click(function (event) {
      event.stopPropagation();
      var windowWidth = $(window).width();
      if (windowWidth <= 767) {
        $(".products-categories-tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");
        $('.products-categories-tabs .tab-list .tab-panel-outer ul').slideUp();

      }
    });

    // var winWidth = $(window).width();
    // if (winWidth <= 767) {
    //     $('.products-categories-tabs .tab-list').on('click', '.tab-panel-outer > ul > li > a', function () {
    //         var tabHeight = $('.products-categories-tabs .tabs-wrap .tab-content-outer .tab-content .tab-pane.show').outerHeight();
    //         $('.products-categories-tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});
    //     });
    // } else {
    //     $('.products-categories-tabs .tabs-wrap .tab-content-outer').removeAttr('style');
    // }
  });

  $(window).on("load resize", function () {
    var winWidth = $(window).width();
    var tabHeight = $('.products-categories-tabs .tabs-wrap .tab-content-outer .tab-content').outerHeight();

    if (winWidth <= 767) {
      $('.products-categories-tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});
    } else {
      $('.products-categories-tabs .tabs-wrap .tab-content-outer').removeAttr('style');
    }

    $('.tabs .tab-list .tab-panel-outer .responsive-tab li ').on('click', function (e) {
      e.stopPropagation();
      var tabHeight = $('.tabs .tabs-wrap .tab-content-outer .tab-content').outerHeight();
      $('.tabs .tabs-wrap .tab-content-outer').css({'height': tabHeight});
    });
  });

  //On load function
  $(window).on("load resize", function () {
    windowWidth = jQuery(window).width();
    if (windowWidth > 767) {
      $(".products-categories-tabs .tab-list .tab-panel-outer ul").removeAttr("style");
      $(".products-categories-tabs .tab-list .tab-panel-outer .caret").removeClass("closeup");
    }
  });

  $(window).on("load", function () {
    $(".products-categories-tabs .tabs-wrap .tab-list ul li").unwrap();
    // $(".products-categories-tabs .tabs-wrap .tab-list ul li").unwrap();
    // $(".products-categories-tabs .tabs-wrap .tab-list ul li").unwrap();
    $('.products-categories-tabs .tabs-wrap .tab-list ul li:first-child').addClass('active');
    $('.products-categories-tabs .tabs-wrap .tab-list ul li:first-child a').addClass('active');

    $(".products-categories-tabs .tabs-wrap .tab-content-outer .tab-content .tab-pane").unwrap();
    $(".products-categories-tabs .process-list li").unwrap().unwrap().unwrap();
    $(".products-categories-tabs .process-list .link-icon").unwrap().unwrap().unwrap();
  });

  var categories_geo;
  function product_categories_link() {
    setTimeout(function () {
      categories_geo = $('body').attr('data-region');
      $('.products-categories-tabs .tabs-wrap .tab-content-outer .tab-content .process-list').find('li').removeClass('New');
      // For product nav only
      $('.products-categories-tabs .tabs-wrap .tab-content-outer .tab-content .process-list').find('li').each(function () {

        // console.log(this);
        if ($(this).hasClass('Australia') && (categories_geo === 'australia') || $(this).hasClass('all')) {

        } else if ($(this).hasClass('Zealand') && (categories_geo === 'new_zealand') || $(this).hasClass('all')) {


        } else if ($(this).hasClass('India') && (categories_geo === 'in') || $(this).hasClass('all')) {


        } else if ($(this).hasClass('Africa') && (categories_geo === 'africa') || $(this).hasClass('all')) {

        } else {
          $(this).remove();
        }
      });

    }, 500);
  }

  $(document).ready(function () {
    product_categories_link();
  });

})(jQuery);